import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelperService } from 'src/app/services/helper/helper.service';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'flight-compact-card',
  templateUrl: './flight-compact-card.component.html',
  styleUrls: ['./flight-compact-card.component.scss'],
})
export class FlightCompactCardComponent implements OnInit {
  @Input() flight: any;
  @Output() closeModal?: EventEmitter<any> = new EventEmitter();
  constructor(
    private helperService: HelperService,
    private navControl: NavController
  ) {}

  ngOnInit() {}

  navigateToDetail(flight: any) {
    let legNo = this.helperService.generateLegNo(
      flight.flightid,
      flight.startdate,
      flight.origin,
      flight.dest
    );
    if(this.closeModal){
      this.closeModal.emit();
    }
    this.navControl.navigateForward(['flight/', legNo]);
  }

}
